import { GameSceneMVC } from '../../game/scene/GameSceneMVC';
import { createDiv, createElement } from '../../libs/HTML/HTMLElementCreator';
import type { Scene, SceneManager } from '../SceneManager';

export function showRefillsDebugPanel(gameScene: GameSceneMVC, sceneManager: SceneManager): void {
  const panelElement = createDiv({
    parentElement: document.body,
    elementID: 'refills-debug-panel',
    style: {
      position: 'fixed',
      right: '0%',
      top: '75px',
      minWidth: '150px',
      margin: '5px 5px 5px 5px',
      padding: '5px 5px 5px 5px',
      backgroundColor: '#aaaaaa',
    },
  });

  const span = createElement('span', {
    parentElement: panelElement,
    style: {
      color: 'white',
    },
  });

  span.innerHTML = 'Current Refill Settings';

  let hidden = false;

  const textArea = createDiv({
    parentElement: panelElement,
    style: {
      minWidth: '150px',
      minHeight: '25px',
      marginTop: '5px',
      backgroundColor: '#ffffff',
      fontSize: '0.8em',
      color: 'black',
      textWrap: 'nowrap',
      whiteSpace: 'pre-wrap',
    },
  });

  span.addEventListener('click', () => {
    hidden = !hidden;
    textArea.style.display = hidden ? 'none' : '';
  });

  const trayModel = gameScene.debugGetTrayModel();

  const updateRefillText = (): void => {
    const refillSettings = trayModel.refillRandomizer.getCurrentRefillSettings() ?? {};
    textArea.innerHTML = JSON.stringify(refillSettings, null, 2).replace(/[{}]/g, '').trim();
  };

  updateRefillText();
  trayModel.refillRandomizer.onRefillSettingsChanged.connect(updateRefillText);

  // Clear on scene change.
  const onSceneActivated = (scene: Scene): void => {
    trayModel.refillRandomizer.onRefillSettingsChanged.disconnect(updateRefillText);
    sceneManager.onSceneActivated.disconnect(onSceneActivated);
    panelElement.remove();

    const isReplay = scene instanceof GameSceneMVC && !scene.options.saveProgress;
    if (isReplay) {
      showRefillsDebugPanel(scene, sceneManager);
    }
  };

  sceneManager.onSceneActivated.connect(onSceneActivated);
}
